import React from "react";
import { useStore } from "react-redux";
import { AppState } from "../store/rootReducer";
import { useDialog } from "../providers/DialogProvider";
import ErrorDialog from "../Components/Dialogs/ErrorDialog";
import { getLeaseQuoteRefusal, LeaseSendAction } from "../utils/leaseQuoteSolveUtils";

/**
 * Shows why the open Lease app cannot be desked, posted or have its schedule printed yet, and returns true when it
 * cannot. Reads the latest page state, since a re-solve may just have run.
 */
export const useLeaseQuoteRefusal = () => {
  const store = useStore<AppState>();
  const [openDialog, closeDialog] = useDialog();

  return (action: LeaseSendAction): boolean => {
    const applications = store.getState().applications;
    const refusal = getLeaseQuoteRefusal(applications.editingApp, applications.applicationLeaseQuoteIsDirty,
      applications.applicationLeaseQuoteNeedsSolve, action);
    if (refusal) {
      openDialog({ children: <ErrorDialog title="Lease Quote Must Be Solved" errors={[refusal]} closeDialog={closeDialog} /> });
    }
    return !!refusal;
  };
};
